<template>
  <div class="cont-pingjia have-tit">
    <div class="user-much-num">
      <span :class="{'active': selectIndex === 0 ? true : false}" @click="selectEvent(0)">好友给他的评价</span> |
      <span :class="{'active': selectIndex === 1 ? true : false}" @click="selectEvent(1)">他给好友的评价</span>
    </div>
    <div class="pingjia-cont">
      <div class="left-right-content clearfix">
        <div class="c-left">
          <div class="firends" v-if="selectIndex === 0">
            <div class="console-ipt">
              <el-input
                class="textarea"
                type="textarea"
                :rows="1"
                placeholder="请输入内容"
                v-model="textCon"
              >
              </el-input>
              <div class="checked-btn clearfix">
                <el-button class="fabu-btn" type="primary" size="mini">评价</el-button>
              </div>
            </div>
            <!-- <talk-sec list-title="全部评价"></talk-sec> -->
          </div>
          <div class="his" v-if="selectIndex === 1">
            <!-- <talk-sec list-title="全部评价"></talk-sec> -->
          </div>
        </div>
        <div class="c-right">
          <div class="one-item">
            <div class="one-title">
              访客
            </div>
            <div class="user-list clearfix three">
              <div class="dv-user">
                <div class="u-head">
                  <router-link to="/home" class="avatar-f">
                    <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
                  </router-link>
                </div>
                <div class="user-name">人人动画</div>
                <div class="tag">个性标签</div>
              </div>
              <div class="dv-user">
                <div class="u-head">
                  <router-link to="/home" class="avatar-f">
                    <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
                  </router-link>
                </div>
                <div class="user-name">人人动画</div>
                <div class="tag">个性标签</div>
              </div>
              <div class="dv-user">
                <div class="u-head">
                  <router-link to="/home" class="avatar-f">
                    <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
                  </router-link>
                </div>
                <div class="user-name">人人动画</div>
                <div class="tag">个性标签</div>
              </div>
              <div class="dv-user">
                <div class="u-head">
                  <router-link to="/home" class="avatar-f">
                    <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
                  </router-link>
                </div>
                <div class="user-name">人人动画</div>
                <div class="tag">个性标签</div>
              </div>
              <div class="dv-user">
                <div class="u-head">
                  <router-link to="/home" class="avatar-f">
                    <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
                  </router-link>
                </div>
                <div class="user-name">人人动画</div>
                <div class="tag">个性标签</div>
              </div>
              <div class="dv-user">
                <div class="u-head">
                  <router-link to="/home" class="avatar-f">
                    <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
                  </router-link>
                </div>
                <div class="user-name">人人动画</div>
                <div class="tag">个性标签</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import talkSec from '@@/pub/talksec/talksec'
import { mapState } from "vuex";
import updateTdk from "@/utils/tdk";

export default {
  components: {
    // talkSec
  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      selectIndex: 0,
      textCon: ''
    }
  },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
  mounted(){
    this.isMounted = true;
  },
  methods: {
    selectEvent (num) {
      this.selectIndex = num
    }
  }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
.user-much-num{
  span{
    margin: 0 5px;
    cursor: pointer;
    &:first-child{
      margin-left: 0;
    }
    &.active{
      font-weight: bold;
    }
  }
}
.console-ipt{
  padding: 10px;
  // background: #eee;
  .checked-btn{
    margin-top: 5px;
    .fabu-btn{
      float: right;
    }
  }
}
</style>
